import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

import routes from "./router/routes";
import store from "./store/store";

let catalog = document.getElementById("catalog");
if (catalog) {
  let i18n = window.translations;

  Vue.prototype.$postsPerPage = 12;
  Vue.prototype.$i18n = i18n;

  Vue.use(VueRouter);

  const router = new VueRouter({
    routes,
  });

  new Vue({
    el: "#catalog",
    router,
    store,
    render: (h) => h(App),
  });
}



// WEBPACK FOOTER //
// ./src/main.js